import {
  RESOURCE_HANDLER_PACKAGE_SET,
  RESOURCE_HANDLER_STATE_RESET,
  RESOURCE_HANDLER_TEMPLATE_CLEAR,
  RESOURCE_HANDLER_TEMPLATE_FETCH,
  RESOURCE_HANDLER_VIEW_CLEAR,
  RESOURCE_HANDLER_VIEW_FETCH
} from "./resourceHandlerActions";
import {REQUEST_ERROR, REQUEST_SUCCESS} from "../../middlewares/request/requestActions";

const initialState = {
  view: null,
  template: null,
  packageId: null
};

const resourceHandlerReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESOURCE_HANDLER_PACKAGE_SET: {
      return {
        ...state,
        packageId: action.payload.packageId
      };
    }
    case RESOURCE_HANDLER_STATE_RESET: {
      return initialState;
    }
    case RESOURCE_HANDLER_VIEW_CLEAR:
      return {
        ...state,
        view: null
      };
    case RESOURCE_HANDLER_TEMPLATE_CLEAR:
      return {
        ...state,
        template: null
      };
    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case RESOURCE_HANDLER_VIEW_FETCH: {
          const view = action.payload.response;
          return {
            ...state,
            view: {
              ...view,
              layouts: view?.layouts ? JSON.parse(view.layouts) : {},
              hasError: false
            }
          };
        }
        case RESOURCE_HANDLER_TEMPLATE_FETCH: {
          const template = action.payload.response;
          return {
            ...state,
            template: {
              ...template,
              layouts: template?.layouts ? JSON.parse(template.layouts) : {},
              hasError: false
            }
          };
        }

        default:
          return state;
      }
    }
    case REQUEST_ERROR: {
      switch (action.payload.label) {
        case RESOURCE_HANDLER_VIEW_FETCH: {
          return {
            ...state,
            view: {hasError: true}
          };
        }
        case RESOURCE_HANDLER_TEMPLATE_FETCH: {
          return {
            ...state,
            template: {hasError: true}
          };
        }

        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default resourceHandlerReducer;
